// Confirmed question type IDs from the database seed.
// Do NOT use magic numbers in components — reference these constants.

export const QUESTION_TYPE = {
  TEXTBOX: 1,
  MULTILINE: 2,
  CHECKBOX: 3,
  RADIO: 4,
  NUMERIC: 5,
  ALPHANUMERIC: 6,
  DATE: 7,
} as const;

export type QuestionTypeId = (typeof QUESTION_TYPE)[keyof typeof QUESTION_TYPE];

// Types that use an option list (Checkbox, Radio)
export const OPTION_BASED_TYPES: ReadonlySet<number> = new Set([
  QUESTION_TYPE.CHECKBOX,
  QUESTION_TYPE.RADIO,
]);

// Types that support inputFormat (Textbox, Multiline, Alphanumeric)
// Includes legacy type ID 9 for Alphanumeric compatibility
export const INPUT_FORMAT_TYPES: ReadonlySet<number> = new Set([
  QUESTION_TYPE.TEXTBOX,
  QUESTION_TYPE.MULTILINE,
  QUESTION_TYPE.ALPHANUMERIC,
  9, // Legacy Alphanumeric type ID from legacy system
]);

// Types that support length validation
// Includes legacy type ID 9 for Alphanumeric compatibility
export const LENGTH_VALIDATED_TYPES: ReadonlySet<number> = new Set([
  QUESTION_TYPE.TEXTBOX,
  QUESTION_TYPE.MULTILINE,
  QUESTION_TYPE.NUMERIC,
  QUESTION_TYPE.ALPHANUMERIC,
  9, // Legacy Alphanumeric type ID from legacy system
]);

// Branching is only available for Radio questions
export const BRANCHING_ENABLED_TYPES: ReadonlySet<number> = new Set([
  QUESTION_TYPE.RADIO,
]);
